export default __webpack_public_path__ + "assets/ab8d85db1aba01458d9d96df0026b23a.jpg";